import 'react-loading-skeleton/dist/skeleton.css';
import '@/multiLanguages';
import '@/styles/custom-notify-toast.css';
import '@/styles/global.css';
import '@/styles/tailwind.css';

import ErrorBoundary from '@/components/atoms/ErrorBoundary';
import { persistor, store } from '@/redux/store';
import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/utils/queryClient';
import { render } from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import reportWebVitals from './reportWebVitals';

render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <BrowserRouter>
            <ErrorBoundary>
              <App />
            </ErrorBoundary>
          </BrowserRouter>
        </HelmetProvider>
      </QueryClientProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

reportWebVitals();
